'use strict';

exports.__esModule = true;

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _reduxApiMiddleware = require('redux-api-middleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Provider = (_temp = _class = function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    var store = props.store,
        options = _objectWithoutProperties(props, ['store']);

    _this.state = {
      store: store || (0, _redux.createStore)((0, _redux.combineReducers)({ connect: _reducers2.default }), (0, _redux.applyMiddleware)((0, _reduxApiMiddleware.apiMiddleware)({}))),
      options: options
    };
    return _this;
  }

  Provider.prototype.getChildContext = function getChildContext() {
    var _state = this.state,
        store = _state.store,
        options = _state.options;

    return { store: store, options: options };
  };

  Provider.prototype.render = function render() {
    return this.props.children;
  };

  return Provider;
}(_react.Component), _class.childContextTypes = {
  store: _propTypes2.default.object,
  options: _propTypes2.default.object
}, _temp);
exports.default = Provider;
module.exports = exports['default'];